export const DEACTIVATE = 'Deactivate';
export const DELETE = 'Delete';
export const DIVIDER = 'Divider';
export const ADD = 'Add Planner';
export const EDIT_CAMPAIGN = 'Edit Campaign';
